import noImage from '../../assets/noimagegold.png'
import featuredIcon from '../../assets/icons/featured.svg'

import noMasterclass from '../../assets/icons/master_classes.svg'

export const translations = {
    title: 'Masterclasses',
    time:{
        hours:'hrs',
        minutes:'mins',
        seconds:'secs'
    },
    noMasterclass: {
        title: 'No masterclasses to show',
        subtitle: 'Masterclasses will show here.',
        icon: noMasterclass
    },
    filter: [
        { id: 'all', value: 0, label: 'All' }
    ],
    form: {
        search: {
            placeholder: 'Search by title...'
        },
        title: {
            label: 'Title',
            placeholder: 'Title',
        },
        dimensions: {
            label: 'Dimensions',
            placeholder: 'Dimensions',
        },
        technique: {
            label: 'Technique',
            placeholder: 'Technique',
        },
        price: {
            label: 'Price',
            placeholder: 'Price',
        },
        description: {
            label: 'Description',
            placeholder: 'Description',
        },
        date: {
            label: 'Date',
            //placeholder: 'Date',
        },
        sold: {
            label: 'Sold'
        },
        nft: {
            label: 'NFT'
        },
        external_url: {
            label: 'NFT Link',
            placeholder: 'NFT Link',
        },
    },
    add_button: 'Add',
    noImage: noImage,
    noContent: 'There are not coincidences with the filters selected.',
    data: {
        title: 'Title',
        start_date: 'Date'
    },
    featured: featuredIcon
}